import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  noImage: "_0mn18c350u",
  accent: "_0ma116edm1"
});
const wrapper = "_0mwswa7sp";
const image = "_0mie766rz";
const textWrapper = "_0mt10oexrp";
const heading = "_0mh11dwudw";
const description = "_0mdc8se2d";

export { description, heading, image, modifiers, textWrapper, wrapper };
import "./_card.style.linaria.module.css";
//# sourceMappingURL=_card.style.js.map
